// Bottone "Invia link impostazione password": l'operatore invia al candidato lo stesso link
// che il candidato può chiedere da solo con "Primo accesso o password dimenticata?" (backend: /password-reset/request)
import React, { useState } from 'react';
import { useRecordContext, Confirm, useNotify } from 'react-admin';
import axios from 'axios';

import LockResetIcon from '@mui/icons-material/LockReset';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { sendButtonCss } from '../shared/Styles/buttonStyles';

import config from '../../config/config.json';

const host = config.production.host;

export const SendPasswordLinkButton = () => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const notify = useNotify();

    if (!record || record.roles !== 'candidato') return null;

    const handleConfirm = async () => {
        setOpen(false);
        setIsLoading(true);
        try {
            await axios.post(host + '/password-reset/request', { email: record.email });
            notify('Richiesta inviata. Se non arriva, attendere 2 minuti prima di riprovare.', { type: 'info' });
        } catch (error) {
            notify(`Errore: ${error.message}`, { type: 'warning' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading ? (
                <CircularProgress size={24} sx={{ color: '#e85a2c' }} />
            ) : (
                <Button
                    sx={sendButtonCss}
                    onClick={() => setOpen(true)}
                    variant="contained"
                    size="small"
                    endIcon={<LockResetIcon />}
                    color="primary"
                >
                    INVIA LINK IMPOSTAZIONE PASSWORD
                </Button>
            )}
            <Confirm
                isOpen={open}
                loading={isLoading}
                title="Invia link impostazione password"
                content={`Inviare a ${record.email} un link per impostare una nuova password? Il link vale 60 minuti e annulla eventuali link inviati in precedenza.`}
                onConfirm={handleConfirm}
                onClose={() => setOpen(false)}
                confirm="Si"
                cancel="No"
            />
        </>
    );
};
